//export const BaseUrl = "";
//export const BaseUrl = "https://gpa-test.sise.envir.ee";
export const BaseUrl = "https://gpa.maaamet.ee";
//export const BaseUrl = "https://localhost";
export const ApiBaseUrl = BaseUrl + "/api";
